export default [
  {
    value: "farming",
    label: "Farming",
    sublabel:
      "Rearing of animals and/or cultivation of plants <br/>Examples: agriculture, irrigation, aquaculture, plantations, herding, pests and diseases affecting crops and livestock"
  },
  {
    value: "biota",
    label: "Biota",
    sublabel:
      "Flora and/or fauna in natural environment <br/>Examples: wildlife, vegetation, biological sciences, ecology, wilderness, sealife, wetlands, habitat"
  },
  {
    value: "boundaries",
    label: "Boundaries",
    sublabel:
      "Legal land descriptions <br/>Examples: political and administrative boundaries"
  },
  {
    value: "climatologyMeteorologyAtmosphere",
    label: "Climatology / Meteorology / Atmosphere",
    sublabel:
      "Processes and phenomena of the atmosphere. <br/>Examples: cloud cover, weather, climate, atmospheric conditions, climate change, precipitation"
  },
  {
    value: "economy",
    label: "Economy",
    sublabel:
      "Economic activities, conditions and employment. <br/>Examples: production, labour, revenue, commerce, industry, tourism and ecotourism, forestry, fisheries, commercial or subsistence hunting, exploration and exploitation of resources such as minerals, oil and gas"
  },
  {
    value: "elevation",
    label: "Elevation",
    sublabel:
      "Height above or below sea level <br/>Examples: altitude, bathymetry, digital elevation models, slope, derived products"
  },
  {
    value: "environment",
    label: "Environment",
    sublabel:
      "Environmental resources, protection and conservation <br/>Examples: environmental pollution, waste storage and treatment, environmental impact assessment, monitoring environmental risk, nature reserves, landscape"
  },
  {
    value: "geoscientificInformation",
    label: "Geoscientific Information",
    sublabel:
      "Information pertaining to earth sciences <br/>Examples: geophysical features and processes, geology, minerals, sciences dealing with the composition, structure and origin of the earth’s rocks, risks of earthquakes, volcanic activity, landslides, gravity information, soils, permafrost, hydrogeology, erosion"
  },
  {
    value: "health",
    label: "Health",
    sublabel:
      "Health, health services, human ecology, and safety Examples: disease and illness, factors affecting health, hygiene, substance abuse, mental and physical health, health services"
  },
  {
    value: "imageryBaseMapsEarthCover",
    label: "Imagery / Base maps / Earth cover",
    sublabel:
      "Base maps <br/>Examples: land cover, topographic maps, imagery, unclassified images, annotations"
  },
  {
    value: "intelligenceMilitary",
    label: "Intelligence / Military",
    sublabel:
      "Military bases, structures, activities <br/>Examples: barracks, training grounds, military transportation, information collection"
  },
  {
    value: "inlandWaters",
    label: "Inland waters",
    sublabel:
      "Inland water features, drainage systems and their characteristics Examples: rivers and glaciers, salt lakes, water utilization plans, dams, currents, floods, water quality, hydrographic charts"
  },
  {
    value: "location",
    label: "Location",
    sublabel:
      "Positional information and services <br/>Examples: addresses, geodetic networks, control points, postal zones and services, place names"
  },
  {
    value: "oceans",
    label: "Oceans",
    sublabel:
      "Features and characteristics of salt water bodies (excluding inland waters) <br/>Examples: tides, tidal waves, coastal information, reefs"
  },
  {
    value: "planningCadastre",
    label: "Planning / Cadastre",
    sublabel:
      "Information used for appropriate actions for future use of the land <br/>Examples: land use maps, zoning maps, cadastral surveys, land ownership"
  },
  {
    value: "society",
    label: "Society",
    sublabel:
      "Characteristics of society and cultures <br/>Examples: settlements, anthropology, archaeology, education, traditional beliefs, manners and customs, demographic data, recreational areas and activities, crime, census information"
  },
  {
    value: "structure",
    label: "Structure",
    sublabel:
      "Man-made construction <br/>Examples: buildings, museums, churches, factories, housing, monuments, shops, towers"
  },
  {
    value: "transportation",
    label: "Transportation",
    sublabel:
      "Means and aids for conveying persons and/or goods <br/>Examples: roads, airports/airstrips, shipping routes, tunnels, nautical charts, vehicle or vessel location, aeronautical charts, railways"
  },
  {
    value: "utilitiesCommunication",
    label: "Utilities / Communication",
    sublabel:
      "Energy, water and waste systems and communications infrastructure and services <br/>Examples: hydroelectricity, geothermal, solar and nuclear sources of energy, water purification and distribution, sewage collection and disposal, electricity and gas distribution, data communication, telecommunication, radio, communication networks"
  }
];
